define('components/tools-button/views/tools-button',[
    'components/tools-button/templates/tools-button'
], function (template) {
    "use strict";

    var pagePath = window.location.pathname.replace(/\/[^\/]+$/, '');

    return Mn.ItemView.extend({


        "template": template,

        "glossaryLauncher": null,

        "events": {
            "focus .tools-dropdown, .tools-options a": "showAccessibility",
            "blur .tools-dropdown, .tools-options a": "hideAccessibility",
            "click li.tool a": "onToolClick"
        },

        "showAccessibility": function(ev){
            $('.tools-options').removeClass('hide-accessibly');
            $('.tools-dropdown').addClass('open');
        },

        "hideAccessibility": function(ev){
            $('.tools-options').addClass('hide-accessibly');
            $('.tools-dropdown').removeClass('open');
        },

        "onToolClick": function (event) {
            var $target = $(event.currentTarget),
                tool = $target.data('tool');

            // Tools launcher is unsupported in editorial
            if (/^editorial\./i.test(window.location.host)) {
                return;
            }

            // the only 'non-tool' so far is glossary,
            // so let's look for that for the time being
            // until a more robust option is warranted
            if (tool.toLowerCase() === 'glossary') {
                this.launchGlossary();
            } else {
                this.launchTool(tool);
            }
        },

        "launchTool": function(toolName){
            var url = pagePath + '/tools.html' + '#' + toolName,
                dimensionsAndLocation = {
                    "Basic Calculator": "height=300,width=380, top=100, left=960",
                    "Mortgage Calculator": "height=505,width=944, top=100, left=400"
                    },
                parameters = "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, "
            window.open(url, toolName, parameters + dimensionsAndLocation[toolName] );
        },

        "launchGlossary": function () {
            if (!this.glossaryLauncher){
                this.glossaryLauncher = new window.de.ux.Windowux({
                    "path": pagePath + '/glossary.html',
                    "target": '_blank',
                    "options": {
                        "width": 1000,
                        "height": 735,
                        "menubar": 'no',
                        "resizable": 'no',
                        "titlebar": 'no',
                        "scrollbars": 'yes',
                        "toolbar": 'no'
                    },
                    "isCenteredLeft": true,
                    "isCenteredTop": true
                }).open();
            }
        },

        "serializeData": function () {
            return _.extend(Mn.LayoutView.prototype.serializeData.call(this), {
                "tools": [
                    {
                        "icon": "calculator",
                        "name": "Basic Calculator"
                    },
                    {
                        "icon": "line-chart",
                        "name": "Mortgage Calculator"
                    },
                    {
                        "icon": "book",
                        "name": "Glossary"
                    }
                ]
            });
        }
    });
});

